import { UserCircleIcon } from "@heroicons/react/solid";
import { Button } from "primereact/button";
import { Menu } from "primereact/menu";
import { MenuItem } from "primereact/menuitem";
import { useRef } from "react";
import { Link } from "react-router-dom";
import { IUser } from "../interfaces/user.interface";
import { AUTH_ROUTES } from "../routes/Constants";
import HelpOutlineIcon from "@mui/icons-material/HelpOutline";
import styles from "./WebLoginOutButtons.module.scss";

interface Props {
    user: IUser | null;
    menuItems: MenuItem[];
}

const WebLoginOutButtons = ({ user, menuItems }: Props) => {
    const menu = useRef<Menu>(null);

    if (user) {
        return (
            <>
                <div className="flex items-center gap-0">
                    <a
                        href="https://wiki.athomearticulation.com/athomearticulationknowledgebase"
                        target="_blank"
                        rel="noopener noreferrer"
                    >
                        <HelpOutlineIcon className={styles.helpIcon} />
                    </a>
                    <Button
                        onClick={(e) => menu.current?.toggle(e)}
                        icon={<UserCircleIcon className="h-7 w-7" />}
                    />
                </div>
                <Menu
                    model={menuItems}
                    popup
                    ref={menu}
                    popupAlignment="right"
                    className={styles.menuItem}
                />
            </>
        );
    } else {
        return (
            <>
                <Link
                    to={`${AUTH_ROUTES.REGISTER}`}
                    className={"text-aha-green py-1 "}
                >
                    SIGN UP
                </Link>
                <div className={"text-gray-500"}>OR</div>
                <Link
                    to={`${AUTH_ROUTES.LOGIN}`}
                    className={
                        "border border-aha-orange bg-aha-orange text-white py-1 px-4 hover:text-aha-orange hover:bg-white transition duration-200 ease-in-out"
                    }
                >
                    LOG IN
                </Link>
            </>
        );
    }
};

export default WebLoginOutButtons;
